import { Component, effect, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthStore, NotAuthorizedReason, OpenIdService } from '@workspace/ng-data-access';
import { AuraLandingProjectionComponent } from '../landing-projection/landing-projection.component';

@Component({
  selector: 'aura-not-authorized',
  templateUrl: './not-authorized.component.html',
  imports: [AuraLandingProjectionComponent, MatButtonModule],
})
export class AuraNotAuthorizedComponent {
  private authStore = inject(AuthStore);
  private openIdService = inject(OpenIdService);
  private router = inject(Router);
  readonly reason = inject(ActivatedRoute).snapshot.queryParamMap.get('reason');

  notAuthorizedReason = NotAuthorizedReason;

  constructor() {
    effect(() => {
      const isAuth = this.authStore.isUserAuthenticated();
      if (!isAuth || this.reason === NotAuthorizedReason.NOT_ADMIN) {
        void this.router.navigate(['']);
      }
    });
  }

  backHome() {
    void this.router.navigate(['']);
  }

  logOut() {
    this.openIdService.logout();
  }
}
